module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/fi-card-drag.8406392e48ec1e8ccf05.gif";